import type { IBatchFilters } from '@pages/batch-operations/batch/components/BatchListFilter.tsx';
import type { ChipColorType } from '@pages/statements/utils';
import { BatchStatus, OperationStatus } from 'types/operations';

export enum OPERATION_TYPE {
	SEPA = 'DOMESTIC',
	INTERNATIONAL = 'INTERNATIONAL',
}

export enum BATCH_OPERATION_TYPE {
	SEPA = 'SEPA',
	INTERNATIONAL = 'SWIFT',
}

export const TRANSACTION_STATUS_COLOR: Record<OperationStatus, ChipColorType> = {
	[OperationStatus.FAILED]: 'error',
	[OperationStatus.EXECUTED]: 'success',
	[OperationStatus.CREATED]: 'warning',
	[OperationStatus.PROCESSED]: 'warning',
	[OperationStatus.SIGNED]: 'warning',
};

export const OTHER_STATUS = [
	OperationStatus.CREATED,
	OperationStatus.FAILED,
	OperationStatus.PROCESSED,
	OperationStatus.SIGNED,
];
export const batchStatusColorConfig: Record<
	BatchStatus,
	'error' | 'success' | 'warning' | 'neutral' | 'primary'
> = {
	FAILED: 'error',
	SIGNED: 'success',
	EXECUTED: 'success',
	CREATED: 'warning',
	UNSIGNED: 'warning',
	INITIALIZING: 'neutral',
	SIGNING: 'primary',
	EXECUTED_WITH_WARNINGS: 'success',
	UNSIGNED_WITH_WARNINGS: 'warning',
};
export const deletableStatuses = [
	BatchStatus.INITIALIZING,
	BatchStatus.UNSIGNED,
	BatchStatus.UNSIGNED_WITH_WARNINGS,
];
export const getDefaultFilters = (): IBatchFilters => ({});
